// Generated by scripts/update-seeq-icons.js from src/svg/seeq/scatterplot.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcScatterplot = {
  prefix: 'fak',
  iconName: 'scatterplot' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e90b',
    'M353.3 721.9c0 48.1-39 87-87.1 87.1s-87-39-87-87.1c0-48.1 39-87 87-87s87 39 87.1 87zM471 491.5c0 48.1-39 87-87 87.1s-87-39-87-87.1c0-48.1 39-87 87-87s87 39 87 87zM696.3 619.5c0 48.1-39 87-87 87.1s-87-39-87.1-87.1c0-48.1 39-87 87.1-87s87 39 87 87zM655.4 261.1c0 48.1-39 87-87.1 87.1s-87-39-87-87.1c0-48.1 39-87 87-87s87 39 87.1 87zM967.7 291.8c0 48.1-39 87-87.1 87.1s-87-39-87-87.1c0-48.1 39-87 87-87s87 39 87.1 87zM117.8 911.4v-890.9c0-10.2-10.2-20.5-20.5-20.5h-76.8c-10.2 0-20.5 10.2-20.5 20.5v947.2c0 30.7 25.6 56.3 56.3 56.3h947.2c10.2 0 20.5-10.2 20.5-20.5v-76.8c0-10.2-10.2-20.5-20.5-20.5h-885.7z',
  ],
} satisfies IconDefinition;
